/*
*
* Eiis event model. Extends CustomEvents.
*
 */
export default class EiisEvents {
	constructor() {
	}

	static on(event, handler) {
		document.addEventListener(event, handler);
	}

	static fire(event, data) {
		//console.log("[EiisEvents] firing event", event, data);
		if (!event) {
			console.error("[EiisEvents] trying to fire an undefined event with this data:", data);
			return;
		}
		let eve = new CustomEvent(event, { detail: data, bubbles: true });
		let cancelled = !document.dispatchEvent(eve);
		if (cancelled)
			console.log("[EiisEvents] event cancelled!");
	}
}
